import { render, staticRenderFns } from "./add_campaign.vue?vue&type=template&id=483eef80&scoped=true&"
import script from "./add_campaign.vue?vue&type=script&lang=js&"
export * from "./add_campaign.vue?vue&type=script&lang=js&"
import style0 from "./add_campaign.vue?vue&type=style&index=0&id=483eef80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483eef80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow})
